import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectOffers = state => state.get('offers', initialState);

const makeSelectOffers = () =>
  createSelector(selectOffers, offersState => offersState.getIn(['offers']));

const makeSelectOffersNumber = () =>
  createSelector(selectOffers, offersState => offersState.get('total'));

const makeSelectLoading = () =>
  createSelector(selectOffers, offersState => offersState.get('loading'));

export { selectOffers, makeSelectOffers, makeSelectOffersNumber, makeSelectLoading };
